/* @flow strict */

import * as React from 'react';
import './download.scss';

type PropsType = {
    isOpen: boolean
};
const DownloadForm = (props: PropsType): React.Element<'div'> => {
    const { isOpen } = props;

    return (
        <div className={`sparxo-checkout-download_tooltip ${isOpen ? 'sparxo-checkout-download_show' : ''}`}>
            Thank you!
        </div>
    );
};

export default DownloadForm;